import { useEffect, useState } from "react";
import api from "./../config/axiosInstance";
import { handleErrors } from "./../utils/common";
import { Link } from "react-router-dom";
import ROUTES from "../routes";

function Dashboard() {

    const [dashboard, setDashboardCounts] = useState({});

    useEffect(() => {

        const getCounts = async () => {
            try {
                const res = await api.get('/dashboard/counts');
                if (res.status === 200) {
                    setDashboardCounts(res.data.dashboard);
                }
            } catch (err) {
                handleErrors(err);
            }
        };

        getCounts();

    }, []);

    return (
        <>
            <div className="form-head d-md-flex mb-sm-4 mb-3 align-items-start">
                <div className="me-auto  d-lg-block">
                    <h2 className="text-black font-w600">Dashboard</h2>
                    <p className="mb-0">Welcome to <strong>Arhetype Admin</strong></p>
                </div>
            </div>

            <div className="row">

                <div className="col-xl-3 col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <Link to={ROUTES.PROJECTS} className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3>{ dashboard && dashboard.projects }</h3>
                                    <span className="fs-14 text-black">Total Projects</span>
                                </div>
                                <span className="border border-primary text-primary rounded p-3">
                                    <i className="fa-solid fa-building fa-2x"></i>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Dashboard
